import angular from 'angular';

export default angular.module('shared').constant('errorCodeConstants', {
    forbidden: '403'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/errorCode.constant.js